import { startTransition } from 'react';
import { Menu, MenuItemProps } from '@mantine/core';

type MenuItemPropsType = MenuItemProps & {
  onClick: () => void;
};

export const MenuItem: React.FC<MenuItemPropsType> = (props) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    startTransition(() => {
      // This is a workaround to avoid the tree updating before the menu closes,
      // which would cause the tree to re-render and loose it's state.
      props.onClick();
    });
  };

  return (
    <Menu.Item {...props} onClick={handleClick}>
      {props.children}
    </Menu.Item>
  );
};
